// extracted by mini-css-extract-plugin
module.exports = {"notificationIcon":"NotificationBadge_notificationIcon__xioSg"};